import { css } from '@/styled-system/css';

export const bannerImageStyles = css.raw({
  margin: 'auto',
  backgroundSize: 'cover',
  backgroundPositionX: { xxl: 'center' },
  backgroundRepeat: { xxl: 'no-repeat' },
  height: { base: '460px', xl: '455px', xxl: '435px' },
});

export const introBannerTextContainerStyles = css.raw({
  position: 'absolute',
  top: 0,
  maxWidth: '892px',
  height: '100%',
});

export const bannerFlexStyles = css.raw({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  marginLeft: { base: '400', xl: 0 },
  paddingBlock: { base: '0', xxl: '400' },
});
